import { useState, useEffect, useRef } from 'react';
import { useGlobal } from './global';
import { useQuery } from '@tanstack/react-query';

export const useJobs = (params) => {
  const { fox } = useGlobal();
  const [jobs, setJobs] = useState([]);
  const [didInit, setDidInit] = useState();
  const [loading, setLoading] = useState();

  useEffect(() => {
    if (!fox) return;
    setLoading(true);
    fox.call('GET', '/api/jobs', params).then((j) => {
      setJobs(j.results);
      setLoading(false);
      setDidInit(true);
    });
  }, [fox]);

  return { loading, didInit, jobs };
};

export const useJob = (id) => {
  const { sdk: fox } = useGlobal();
  const [apiJob, setApiJob] = useState();
  const [job_, setJob_] = useState();
  const [children, setChildren] = useState();

  useEffect(() => {
    if (!fox || !id) {
      return;
    }

    setApiJob();
    setJob_();

    setTimeout(() => {
      fox.call('GET', '/api/jobs/' + id).then((data) => {
        setApiJob(data);
      });
    }, 100);

    const j = new fox.Job(id);
    const updateCb = (data) => {
      if (data && Object.keys(data).length) {
        const combined = { ...(job_ || {}), ...data };
        setJob_(combined);
      }
    };
    const childrenCb = (data) => {
      if (data) {
        setChildren(data);
      }
    };
    j.on('update', updateCb);
    j.on('children', childrenCb);
    return () => {
      j.off('update', updateCb);
      j.off('children', childrenCb);
    };
  }, [fox, id]);

  console.log('yyy apiJob is.:', id, apiJob?.id, apiJob?.jobId, apiJob);
  console.log('yyy job_ is...:', id, job_?.id, job_?.jobId, job_);

  return {
    job: { ...(apiJob || {}), ...(job_ || {}), children },
    api: {
      stop: () => fox.call('POST', `/api/jobs/${id}/stop`),
    },
  };
};

export const useJobData = (id) => {
  const { fox } = useGlobal();
  const [job, setJob] = useState();
  const [loading, setLoading] = useState();

  useEffect(() => {
    if (!fox) return;

    setLoading(true);
    // setJob(null);
    fox.jobs.get(id).then((j) => {
      setJob(j);
      setLoading(false);
    });
  }, [fox, id]);

  return { loading, job };
};
